import React from "react";
import WFIcons from "@components/WFIcons";
import css from '../pages/presenze/calendarioPresenze_WF.module.css'

interface BadgeProps {
    annullata?: boolean,
    label: string | undefined,
    wfStato: 'IN_ATTESA' | 'IN_VALUTAZIONE' | 'ACCETTATA' | 'RIFIUTATA',
}

const BadgeCausaliWF: React.FC<BadgeProps> = ({annullata, label, wfStato}) => {

    const getCausaleWFStyle = function (annullata: boolean) {
        return annullata ? {backgroundColor: "#fff", textDecoration: "line-through", color: "#d96557"} : {}
    }

    return (
        <div className={`${css.badgeGiuCausaliWF} bg-white`} style={getCausaleWFStyle(annullata ? annullata : false)}>
            {!annullata && <WFIcons wfStato={wfStato} size={15}/>}
            <span className="whitespace-nowrap">{label ? label : '????'}</span>
        </div>
    )
}
export default BadgeCausaliWF;


